import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { paths } from '../../../../routing/path';
import { useSelectedVenueId } from '../../../../slices/venue/use-selected-venue';

export interface NotificationSettingsMenuItemProps {
    className?: string;
    marginLeft?: number;
}

export const NotificationSettingsMenuItem = (
    props: NotificationSettingsMenuItemProps
) => {
    const selectedVenueId = useSelectedVenueId();
    if (!selectedVenueId) return null;

    return (
        <LeftMenuItem
            icon="pe-7s-bell"
            label="Notification Settings"
            to={paths.account.notifications}
            className={props.className ?? 'vertical-nav-menu'}
            marginLeft={props.marginLeft ?? -15}
            trackingAction="Notifications"
        />
    );
};
